import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LeadBankService {
  private http = inject(HttpClient);

  getLeadBanks(): Observable<any[]> {
    return this.http
      .get<any>('/api/v1/service/accounts/lookup', {
        withCredentials: true,
      })
      .pipe(
        map(resp => {
          const list = Array.isArray(resp) ? resp : resp?.res || [];
          return this.mapLeadBankOptions(list);
        })
      );
  }

  validateEmail(email: string): Observable<{
    sts: string;
    correctedEmail?: string;
    existingEmailMatches?: string[];
    message?: string;
  }> {
    return this.http
      .post<{
        sts: string;
        correctedEmail?: string;
        existingEmailMatches?: string[];
      }>('/api/v1/service/email/validate', { email }, { withCredentials: true })
      .pipe(
        map((resp: any) => {
          const body = resp?.res ?? resp ?? {};
          const attrs = resp?.attrs ?? body?.attrs;
          const errors = Object.keys(attrs ?? {}).map(key => ({
            key,
            ...(attrs as any)[key],
          }));
          const main = errors.find(err => err.main) ||
            errors[0] || { msg: undefined };
          const message = main.msg || main.key;

          return {
            sts: body.sts ?? resp?.sts,
            correctedEmail: body.correctedEmail ?? resp?.correctedEmail,
            existingEmailMatches:
              body.existingEmailMatches ?? resp?.existingEmailMatches,
            message,
          };
        }),
        catchError(error => {
          const attrs = error?.error?.sts?.attrs;
          const errors = Object.keys(attrs ?? {}).map(key => ({
            key,
            ...(attrs as any)[key],
          }));
          const main = errors.find(err => err.main) ||
            errors[0] || { msg: undefined };
          const message =
            main.msg || main.key || 'FTR_CUSTOMER_INVITE_INVALID_EMAIL';

          return of({
            sts: 'err',
            message,
          });
        })
      );
  }

  submitExternalInvest(payload: any): Observable<any> {
    return this.http.post('/api/v1/service/external-invest', payload, {
      params: { execute: true as any },
      withCredentials: true,
    });
  }

  private mapLeadBankOptions(data: any[] | null | undefined): any[] {
    if (!data || !Array.isArray(data)) return [];
    const unique = new Map<string, any>();

    data.forEach(entry => {
      const name = entry?.name?.name || entry?.name || '';
      const acnId = entry?._id || entry?.id;
      const email = entry?.email || '';
      const domains = Array.isArray(entry?.domains) ? entry.domains : [];
      const lgoImg = entry?.lgoImg || entry?.logoImg;
      const key = acnId || name;

      if (!key) return;
      if (!unique.has(key)) {
        unique.set(key, { acnId, name, email, lgoImg, domains, raw: entry });
      }
    });

    return Array.from(unique.values());
  }
}
